import styled from 'styled-components';
import { rem } from 'polished';
import { NotReadyToBuyOnlineStyled } from '../NotReadyToBuyOnlineStyled';
export const NotReadyToBuyOnlineStyledAP = styled(NotReadyToBuyOnlineStyled)`
    background: ${({ theme }) => theme.colors.grey14};
    border-radius: unset;

    .title {
        font-size: ${rem('18px')};
    }

    .container {
        .wrapper {
            .innerTitle {
                .titleContent {
                    font-size: ${rem('12px')};
                }
                .icon {
                    .icon-wrapper,
                    svg {
                    }
                }
            }

            .innerContent {
                color: black;

                .linkButton {
                    font-size: ${rem('12px')};
                    color: ${({ theme }) => theme.colors.primary};
                    border: unset;
                    background: unset;
                    text-align: left;
                    padding: unset;
                    cursor: pointer;
                    position: relative;
                    width: fit-content;
                    display: flex;
                    align-items: center;

                    .txt {
                        margin-right: ${rem('9px')};
                    }

                    .icon-wrapper {
                        display: flex;

                        svg {
                            height: ${rem('7px')};
                            width: ${rem('11px')};

                            path {
                                fill: ${({ theme }) => theme.colors.primary} !important;
                                stroke: ${({ theme }) => theme.colors.primary} !important;
                            }
                        }
                    }

                    &:hover {
                        &:after {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 1px;
                            background-color: ${({ theme }) => theme.colors.primary};
                        }

                        .icon-wrapper {
                            svg path {
                                fill: ${({ theme }) => theme.colors.primary} !important;
                                stroke: ${({ theme }) => theme.colors.primary} !important;
                            }
                        }
                    }
                }

                .innerContentTxt {
                    .contentItem {
                        font-size: ${rem('12px')};
                        line-height: 1.67;
                    }
                }
            }
        }
    }
`;
